<script setup lang="ts">
	interface NavigationItem {
		label: string,
		name: string,
		slug?: string,
		title: string,
		children?: Array<NavigationItem>
	}
	export type {
		NavigationItem
	}
	const { items, footerItems = []} = defineProps<{
		items: Array<NavigationItem>,
		footerItems?: Array<NavigationItem[]>,
	}>()
</script>

<template>
	<nav v-if="items && items.length" role="navigation">
		<ul class="divide-y divide-gray-200">
			<li v-for="item in items.concat(footerItems)" class="relative py-2.5 lg:py-4">
				<NuxtLink v-if="item.name" :to="{name: item.name, params: item.slug ? { article_slug: item.slug } : {}}" class="flex justify-between text-[1.1rem] sm:text-[1.25rem] whitespace-nowrap text-gray hover:text-primary transition duration-300 ease-in-out" :title="item.title" no-prefetch>
					<span>{{ item.label }}</span>
					<GsIcon v-if="item.children?.length || item.slug === 'leistungen'" name="lucide-chevron-down" class="my-auto size-7 text-gray-200" />
				</NuxtLink>
				<span ref="dropdown" class="block overflow-hidden border-l-[5px] border-l-primary">
					<span v-if="item.children?.length" class="flex flex-col gap-5 2xl:gap-5.5 px-4 py-4 bg-white">
						<NuxtLink v-for="subItem in item.children"  :to="{name: subItem.name, params: subItem.slug && subItem.name == 'article-detail' ? { article_slug: subItem.slug } : {}, query: subItem.query ? subItem.query : {}}" class="leading-none relative font-thin text-[1rem] lg:text-[1.1rem] whitespace-nowrap transition duration-500 ease-in-out" :title="subItem.title" no-prefetch>
							{{ subItem.label }}
						</NuxtLink>
					</span>
					<ServiceAreaNavigationDropdownItems v-else-if="item.slug === 'leistungen'" />
				</span>
			</li>
		</ul>
	</nav>
</template>
